<!--
 * @Author: Antigravity
 * @Date: 2026-03-24
 * @Description: 投诉分析-投诉件概况 Cell
-->

<template>
  <div class="w-full flex flex-col">
    <div class="w-full flex items-end justify-between my-16">
      <div class="text-16 font-bold text-black-primary">投诉件概况</div>
    </div>

    <div class="card p-24 flex flex-col items-center">
      <div v-if="loading" class="state-text">
        <div class="w-full">加载中...</div>
      </div>
      <div v-else-if="!total && !disposal.length && !nature.length" class="state-text">暂无数据</div>
      <template v-else>
        <!-- 累计投诉总额 -->
        <div class="flex flex-col items-center mb-24">
          <span class="total-label mb-8">累计投诉</span>
          <div class="flex items-baseline gap-4">
            <span class="total-value">{{ formatNumber(total) }}</span>
            <span class="unit">件</span>
          </div>
        </div>

        <div class="divider w-full bg-[#EBEDF0] h-1 mb-20"></div>

        <!-- 维度切换开关 -->
        <div class="switcher mb-20">
          <div class="switch-item" :class="{ 'active': activeTab === 'disposal' }" @click="activeTab = 'disposal'">按处置进度
          </div>
          <div class="switch-item" :class="{ 'active': activeTab === 'nature' }" @click="activeTab = 'nature'">按投诉件性质
          </div>
        </div>

        <!-- 维度数据列表 -->
        <div class="grid w-full">
          <div v-for="(item, index) in displayList" :key="index" class="grid-item">
            <div class="item-label mb-8">{{ item.label }}</div>
            <div class="flex items-baseline gap-2">
              <span class="item-value">{{ formatNumber(item.value) }}</span>
              <span class="item-unit">件</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import APIS from "@/service/modules/complaintApis/modules/visualization.js";
import visualFilterMixin from "../../mixins/visualFilterMixin";

export default {
  name: "ComplaintOverviewCell",
  mixins: [visualFilterMixin],
  data() {
    return {
      activeTab: 'disposal', // 'disposal' | 'nature'
      loading: false,
      total: 0,
      disposal: [],
      nature: []
    };
  },
  computed: {
    displayList() {
      return this[this.activeTab] || [];
    }
  },
  methods: {
    formatNumber(n) {
      if (!n && n !== 0) return "0";
      return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onLoad() {
      const { areaId, beginTime, endTime, rule, channel } = this.filterParams;
      const params = {
        cityId: areaId,
        startDate: beginTime,
        endDate: endTime,
        rule: rule,
        channel: channel
      };

      this.loading = true;
      APIS.getOverviewCount(params).then(res => {
        if (res && res.ret === 0) {
          const data = res.data || {};
          this.total = data.total || 0;
          this.disposal = Array.isArray(data.disposal) ? data.disposal : [];
          this.nature = Array.isArray(data.nature) ? data.nature : [];
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.card {
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
}

.state-text {
  width: 100%;
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

.total-label {
  font-size: 14px;
  color: #333;
  padding: 2px 4px;
  border-radius: 2px;
}

.total-value {
  font-size: 36px;
  font-weight: 700;
  color: #1E2226;
  line-height: 42px;
}

.unit {
  font-size: 14px;
  color: #666;
}

.switcher {
  display: flex;
  border: 1px solid #36B374;
  border-radius: 4px;
  overflow: hidden;

  .switch-item {
    padding: 6px 0;
    width: 100px;
    text-align: center;
    font-size: 14px;
    color: #36B374;
    cursor: pointer;
    transition: all 0.2s;

    &.active {
      background: #36B374;
      color: #fff;
    }
  }
}

.grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px 0;

  .grid-item {
    width: 33.33%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .item-label {
      font-size: 14px;
      color: #999;
    }

    .item-value {
      font-size: 18px;
      font-weight: 700;
      color: #1E2226;
    }

    .item-unit {
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
